import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { zxPositioning, zxStats } from '@/mocks/zhongxian-commerce';

export default function Positioning() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_0.95fr] gap-8 lg:gap-14 items-start">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap">
                <i className="ri-compass-3-line"></i>
                平台定位
              </span>
              <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
                以数利民 · 以商带农 · 以虚促实
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                {zxPositioning.paragraph}
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {zxPositioning.bases.map((b) => (
                  <div
                    key={b.title}
                    className="p-5 rounded-lg bg-background-100 border border-background-200"
                  >
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${b.icon} text-xl`}></i>
                    </span>
                    <h3 className="mt-3 font-heading font-bold text-base text-foreground-950">{b.title}</h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600">{b.desc}</p>
                  </div>
                ))}
              </div>

              <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
                {zxPositioning.connective}
              </p>
            </div>
          </Reveal>

          <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {zxPositioning.claims.map((c, idx) => (
                <Reveal key={c.title} delay={idx * 80}>
                  <div className="h-full p-5 rounded-lg bg-background-100 border border-background-200 transition-colors hover:border-primary-300">
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                      <i className={`${c.icon} text-xl`}></i>
                    </span>
                    <h3 className="mt-3 font-heading font-bold text-base text-foreground-950">{c.title}</h3>
                    <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={160}>
              <div className="grid grid-cols-2 gap-4">
                {zxStats.map((s) => (
                  <div key={s.label} className="p-5 rounded-lg bg-background-100 border border-background-200">
                    <div className="flex items-baseline gap-1">
                      <span className="font-heading font-bold text-2xl md:text-3xl text-primary-600">{s.value}</span>
                      <span className="text-sm text-foreground-500">{s.unit}</span>
                    </div>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{s.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}